import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { RequiresPermissionsModule } from '../directives';
import { ThumbnailModule } from '../thumbnail/thumbnail.module';
import { TripDriverDetailComponent } from './trip-driver-detail.component';

@NgModule({
  declarations: [TripDriverDetailComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatRippleModule,
    MatTooltipModule,
    UzurvPipesModule,
    UzurvDirectivesModule,
    RequiresPermissionsModule,
    ThumbnailModule
  ],
  exports: [TripDriverDetailComponent]
})
export class TripDriverDetailModule {}
